import type { Viewer } from '@cesiumgs/cesium-analytics'
import { CustomDataSource, Event, ScreenSpaceEventHandler } from '@cesiumgs/cesium-analytics'
import { DrawEventType } from './DrawEventType'
import { type DrawOptions } from './DrawOptions'
import type { DrawResult } from './DrawResult'

/**
 * This is Abstract Class
 * @abstract
 */
export default abstract class DrawAction {
  /**
 * @internal
 */
  vertexCompleteHandlerInstance?: ScreenSpaceEventHandler
  /**
 * @internal
 */
  vertexAddHandlerInstance?: ScreenSpaceEventHandler
  /**
 * @internal
 */
  cursorUpdateHandlerInstance?: ScreenSpaceEventHandler
  /**
 * @internal
 */
  updateEvt: Event /** mouse move  */
  /**
 * @internal
 */
  completeEvt: Event /** complete */
  /**
 * @internal
 */
  addEvt: Event
  /**
 * @internal
 */
  viewer: Viewer
  /**
 * @internal
 */
  drawoptions?: DrawOptions
  /**
 * @internal
 */
  drawResults: DrawResult
  /**
 * @internal
 */
  dataSource: CustomDataSource
  /**
 * @internal
 */
  type: string | undefined
  /**
 * @internal
 */
  state: string

  /**
   *
   * @param {Viewer} viewer mapView
   * @param {DrawOptions} drawoptions init options
   */
  constructor(viewer: Viewer, drawoptions?: DrawOptions) {
    this.viewer = viewer
    this.drawoptions = drawoptions
    this.updateEvt = new Event()
    this.completeEvt = new Event()
    this.addEvt = new Event()
    this.state = 'end'
    this.vertexAddHandlerInstance = new ScreenSpaceEventHandler(
      this.viewer.canvas,
    )
    this.cursorUpdateHandlerInstance = new ScreenSpaceEventHandler(
      this.viewer.canvas,
    )
    this.vertexCompleteHandlerInstance = new ScreenSpaceEventHandler(
      this.viewer.canvas,
    )
    this.drawResults = {
      postions: [],
    }

    this.dataSource = new CustomDataSource('_draw_source')
    this.viewer.dataSources.add(this.dataSource)
    this.registerViewerEvent()
  }

  /**
   * Initialization method
   */
  abstract registerViewerEvent(): void

  /**
   *Delete listening mode
   */
  abstract removeListener(): void
  /**
 * @internal
 */
  complete(): void {
    if (this.drawResults) {
      this.completeEvt.raiseEvent(this.drawResults.postions)
    }
    this.removeListener()
    this.state = 'end'
  }

  /**
 * @internal
 */
  clear(): void {
    this.removeListener()
    this.dataSource.entities.removeAll()
    this.state = 'end'
  }

  /**
 * @internal
 */
  clearEntity(): void {
    this.dataSource.entities.removeAll()
    // this.state = 'end';
  }

  /**
  * @internal
  */
  destroy(): void {
    this.clear()
    this.viewer.dataSources.remove(this.dataSource)
  }

  /**
 * @internal
 */
  on(type: DrawEventType, handler: (evt: any) => any): void {
    switch (type) {
      case DrawEventType.CursorUpdate:
        this.updateEvt.addEventListener(handler)
        break
      case DrawEventType.Complete:
        this.completeEvt.addEventListener(handler)
        break
      case DrawEventType.VertexAdd:
        this.addEvt.addEventListener(handler)
        break
    }
  }
}
